import render from '../utils/render';

/**
 * Preloader template
 * @returns {Element}
 */
export default () => render('<div class="gc-preloader" />').element;
